import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import classes from './EquipmentModal.module.css';

export const EquipmentModal = ({selectedEquipment, isOpen, setIsOpen, onClose}) => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth < 480;
    }
    return false;
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 480);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleClose = () => {
    // Delegate URL/history management to parent when provided
    if (typeof onClose === 'function') {
      onClose();
    } else if (typeof setIsOpen === 'function') {
      setIsOpen(false);
    }
  }

  const handleClickOutside = (e) => {
    if (e.target.classList.contains(classes.equipmentModalBackground)) {
      handleClose();
    }
  }

  const modalContent = (
    <>
      <div className={`${classes.equipmentModalBackground} ${isOpen ? classes.containerSlideUp : ''}`} onClick={handleClickOutside}></div>
      <div className={`${classes.container} ${isOpen ? classes.containerSlideUp : ''}`}>
        {selectedEquipment && (
          <>
            <header className={classes.header}>
              <h3 className={`${classes.headerTitle} semiboldMiddle`}>{selectedEquipment?.category}</h3>
              <svg onClick={handleClose} xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M7.50947 9L0 1.49054L0.990535 0.5L8.5 8.00947L16.0095 0.5L17 1.49054L9.49054 9L17 16.5095L16.0095 17.5L8.5 9.99054L0.990535 17.5L0 16.5095L7.50947 9Z" fill="#1F1F1F"/>
              </svg>
            </header>
            <div className={classes.content}>
              <div className={classes.contentItemContainer}>
                {selectedEquipment?.items?.map((item) => (
                  <div key={item?.id} className={classes.contentItem}>
                    <span className="regularMiddle">{item?.name}</span>
                    <span className="regularMiddle">{item?.count}</span>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );

  if (isMobile) {
    return createPortal(modalContent, document.body);
  }
  return modalContent;
};

export default EquipmentModal;
